import { render, staticRenderFns } from "./vue_report_suspect_table.vue?vue&type=template&id=1e196a2f&scoped=true"
import script from "./vue_report_suspect_table.vue?vue&type=script&lang=js"
export * from "./vue_report_suspect_table.vue?vue&type=script&lang=js"
import style0 from "./vue_report_suspect_table.vue?vue&type=style&index=0&id=1e196a2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e196a2f",
  null
  
)

export default component.exports